// Vendor libraries
import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../impersonation-menu/impersonation-menu.component";
function UserMenuComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "a", 4);
    i0.ɵɵtext(2, " Subscribe Now ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", "/entitlements/unpaid_trial_wall", i0.ɵɵsanitizeUrl);
} }
function UserMenuComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-impersonation-menu", 5);
    i0.ɵɵlistener("addErrorMessageHandler", function UserMenuComponent_Conditional_2_Template_ycn_impersonation_menu_addErrorMessageHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.addErrorMessageHandler.emit($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(1, "div", 6);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("userMenuActive", ctx_r1.userMenuActive);
} }
function UserMenuComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵelement(1, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    i0.ɵɵproperty("href", option_r3.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("data-test-id", option_r3.dataTestId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", option_r3.title);
} }
/**
 *
 * UserMenu Component
 *
 */
export class UserMenuComponent {
    constructor() {
        this.userMenuActive = false;
        this.addErrorMessageHandler = new EventEmitter();
        this.USER = window.USER;
        this.menuOptions = [];
    }
    ngOnInit() {
        const nextLogoutLink = `/logout?next=${window.location.pathname}`;
        const nextLoginLink = `/login?next=${window.location.pathname}`;
        const authenticatedOptions = [
            {
                title: 'Account Settings',
                href: '/accounts/account_settings/profile',
                dataTestId: 'user-menu-account-settings',
            },
            {
                title: 'Go to Admin',
                href: '/admin/',
                includeCondition: () => this.USER.isStaff,
            },
            {
                title: 'Return to Admin User',
                href: '/accounts/return_to_admin_user',
                includeCondition: () => this.USER.impersonationState.adminImpersonating,
            },
            {
                title: 'Sign Out',
                href: nextLogoutLink,
                dataTestId: 'user-menu-sign-out',
            },
        ];
        const unauthenticatedOptions = [
            {
                title: 'Free Trial',
                href: '/start_trial',
            },
            {
                title: 'Sign In',
                href: nextLoginLink,
                dataTestId: 'user-menu-sign-in',
            },
        ];
        if (this.USER.authenticated) {
            authenticatedOptions.forEach((option) => {
                if (!option.includeCondition || option.includeCondition()) {
                    this.menuOptions.push(option);
                }
            });
        }
        else {
            unauthenticatedOptions.forEach((option) => this.menuOptions.push(option));
        }
    }
}
UserMenuComponent.ɵfac = function UserMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UserMenuComponent)(); };
UserMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UserMenuComponent, selectors: [["ycn-user-menu"]], inputs: { userMenuActive: "userMenuActive" }, outputs: { addErrorMessageHandler: "addErrorMessageHandler" }, standalone: false, decls: 4, vars: 3, consts: [[1, "dropdown-menu", "dropdown-menu-right", "width-180"], ["class", "dropdown-item btn-wrap", 4, "ngIf"], ["class", "dropdown-item", 3, "href", 4, "ngFor", "ngForOf"], [1, "dropdown-item", "btn-wrap"], [1, "btn", "btn-block", "btn-success", 3, "href"], [3, "addErrorMessageHandler", "userMenuActive"], [1, "dropdown-divider"], [1, "dropdown-item", 3, "href"], [1, "dropdown-item-text", 3, "textContent"]], template: function UserMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, UserMenuComponent_div_1_Template, 3, 1, "div", 1)(2, UserMenuComponent_Conditional_2_Template, 2, 1)(3, UserMenuComponent_a_3_Template, 2, 3, "a", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !!ctx.USER.daysRemainingInTrial);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.USER.impersonationState.showImpersonationMenu ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.menuOptions);
    } }, dependencies: [i1.NgForOf, i1.NgIf, i2.ImpersonationMenuComponent], encapsulation: 2 });
